import { IonItem, IonLabel, IonList } from "@ionic/react";
import { useHistory, useParams } from "react-router";
import { useTranslation } from "react-i18next";
import WithFab from "../../hoc/with-fab";
import WithNavigation from "../../hoc/with-navigation";
import { home } from "ionicons/icons";
import { useSystem } from "../../store/system";
import InfoImg from "../../components/info-image";

import "./styles.css";


const TrawlDoors = () => {
	const { systemId } = useParams<any>();
	const history = useHistory();

	const systemStore = useSystem();

	const { t } = useTranslation();

	return (
		<>
			<WithNavigation preventGoBack={false} text={t("system.trawlGates.title")}>
				<IonList>
					<IonItem
						onClick={() => history.push(`/system/${systemId}/gate-selection`)}
					>
						<IonLabel>{t("system.trawlGates.gateSelection.title")}</IonLabel>
					</IonItem>
					<IonItem
						onClick={() =>
							history.push(`/system/${systemId}/resistance-expansion`)
						}
					>
						<IonLabel>{t("system.trawlGates.resistanceExpansion.title")}</IonLabel>
					</IonItem>
				</IonList>
				<div className="imgContLarge">
					<img src="/assets/trawlGates.png"/>
				</div>
			</WithNavigation>
		</>
	);
};

export default TrawlDoors;
